/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/dashboard',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Users', url: '/dashboard/users', icon: 'Users', is_bookmarked: false},
    ]
  }
}
/* eslint-enable */

